import React from "react";
import { Container, Row, Col, Table, Card } from "react-bootstrap";
import Header from './Header';
import Footer from './Footer';
import RecentPost from './RecentPost';

const SublimeShortcuts = () => {
  return (
    <>
    <Header />
    <div className="full-div" id="blog">
    <Container fluid className="main-sec">
      <Row className="justify-content-center">
        <Col sm={2}></Col>
        <Col sm={7} className="bg-white p-4 shadow mb-3">
          <h1>Sublime Text Power Tips: Must-Know Keyboard Shortcuts</h1>
          <span className="small ms-2">
            <b>Publish By:-</b> CodeInputs
          </span>
          <div className="mt-3 text-center">
            <img
              className="img-fluid"
              src="/graphics/images/Sublime_shortcut.png"
              alt="Sublime text editor"
            />
          </div><br/>
          <p className="mt-4 text-dark">
            Sublime Text is one of the most popular text editors among developers due to its speed, simplicity, and powerful features. Whether you're a beginner or an experienced coder, knowing the right shortcut keys can significantly boost your productivity.
          </p>

          {/* Shortcuts Sections */}
          {renderShortcutSection("General Shortcuts", [
            ["Open File", "Ctrl + O", "Cmd + O"],
            ["Save File", "Ctrl + S", "Cmd + S"],
            ["Save All", "Ctrl + Shift + S", "Cmd + Option + S"],
            ["Close File", "Ctrl + W", "Cmd + W"],
          ])}

          {renderShortcutSection("Navigation Shortcuts", [
            ["Go to Line", "Ctrl + G", "Cmd + G"],
            ["Go to File", "Ctrl + P", "Cmd + P"],
          ])}

          {renderShortcutSection("Editing Shortcuts", [
            ["Duplicate Line", "Ctrl + Shift + D", "Cmd + Shift + D"],
            ["Move Line Up", "Ctrl + Shift + ↑", "Cmd + Ctrl + ↑"],
          ])}

          {renderShortcutSection("Selection Shortcuts", [
            ["Select Line", "Ctrl + L", "Cmd + L"],
            ["Expand Selection", "Ctrl + D", "Cmd + D"],
          ])}

          {renderShortcutSection("Search and Replace Shortcuts", [
            ["Find", "Ctrl + F", "Cmd + F"],
            ["Replace", "Ctrl + H", "Cmd + Option + F"],
          ])}

          {renderShortcutSection("Split View & Layouts", [
            ["Split into Two Columns", "Alt + Shift + 2", "Cmd + Option + 2"],
            ["Split into Three Columns", "Alt + Shift + 3", "Cmd + Option + 3"],
          ])}

          {renderShortcutSection("Indentation & Formatting", [
            ["Auto-Indent", "Ctrl + Shift + P → \"Reindent\"", "Cmd + Shift + P → \"Reindent\""],
          ])}

          {renderShortcutSection("Miscellaneous Shortcuts", [
            ["Open Command Palette", "Ctrl + Shift + P", "Cmd + Shift + P"],
            ["Open Console", "Ctrl + ~", "Cmd + ~"],
          ])}

          <h4>Conclusion</h4>
          <p className="mt-4 text-dark">
            Using shortcut keys in Sublime Text can save you a lot of time and effort while coding. The more you practice, the more efficient you become. Bookmark this list, and soon you'll be coding at lightning speed!
          </p>
        </Col>

        <Col sm={3}>
          <Card className="shadow mb-3">
            <Card.Body>
              <h4 className="head-color">Recent Post</h4>
              <RecentPost />
            </Card.Body>
          </Card>
          <Card className="shadow">
            <Card.Body>
              <h4 className="head-color">Recent Comment</h4>
              <p className="text-muted">No Comments to Show</p>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
    </div>
    <Footer/>
    </>
  );
};

const renderShortcutSection = (title, shortcuts) => (
  <>
    <h4 className="mt-4">{title}</h4>
    <Table striped bordered hover>
      <thead>
        <tr>
          <th>Action</th>
          <th>Windows/Linux</th>
          <th>macOS</th>
        </tr>
      </thead>
      <tbody>
        {shortcuts.map(([action, win, mac]) => (
          <tr key={action}>
            <td>{action}</td>
            <td>{win}</td>
            <td>{mac}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  </>
);

export default SublimeShortcuts;